import { useState } from 'react';
import Logo from "../assets/images/logo.png";
import { translateString } from '../helpers/translator';

const Nav = ({ language }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const openMenu = () => {
        setIsMenuOpen(true);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const languageInsert = language === "en" ? "" : "/ro";

    return (
        <div className="nav-wrapper">
            <div className="container">
                <nav className="home-header__nav row align-items-center">
                    <div className="home-header__logo col-lg-3 col-9">
                        <a href="/"><img src={Logo} alt="A-Z_A logo" className="img-fluid" /></a>
                    </div>
                    <ul className="home-header__menu desktop-only d-flex col-lg-9 justify-content-end">
                        <li className="nav-item">
                            <a href={languageInsert + "/#services"} className="nav-link">
                                <h3 className="section-title">[{translateString("HOME.NAV.item_links_1", language)}]</h3>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href={languageInsert + "/#about"} className="nav-link">
                                <h3 className="section-title">[{translateString("HOME.NAV.item_links_2", language)}]</h3>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a href={languageInsert + "/#quote"} className="nav-link">
                                <h3 className="section-title">[{translateString("HOME.NAV.item_links_3", language)}]</h3>
                            </a>
                        </li>
                    </ul>
                    <div className="menu-trigger col-3 home-header__menu handheld-only">
                        {!isMenuOpen && <span onClick={openMenu}>[{translateString("HOME.NAV.menu", language)}] </span>}
                        {isMenuOpen && (
                            <>
                                {" "}
                                <span onClick={closeMenu}>[{translateString("HOME.NAV.close", language)}] </span>
                                <ul className="home-header__menu home-header__menu-mobile handheld-only">
                                    <li className="nav-item">
                                        <a href="/#services" className="nav-link">
                                            <h3 className="section-title">[{translateString("HOME.NAV.item_links_1", language)}]</h3>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/#about" className="nav-link">
                                            <h3 className="section-title">[{translateString("HOME.NAV.item_links_3", language)}]</h3>
                                        </a>
                                    </li>
                                    <li className="nav-item">
                                        <a href="/#quote" className="nav-link">
                                            <h3 className="section-title">[{translateString("HOME.NAV.item_links_2", language)}]</h3>
                                        </a>
                                    </li>
                                </ul>
                            </>
                        )}
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default Nav;
